// extracted by mini-css-extract-plugin
export var dropdownContainer = "_p5-0";
export var leftAlign = "_p5-4";
export var listItem = "_p5-2";
export var listItemWrapper = "_p5-1";
export var operationText = "_p5-3";